import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import { styled } from '@mui/styles';
import { CHILDREN_PROP_TYPES } from 'propTypes';

const StyledBox = styled(Box)(({ theme, isCatering }) => ({
  width: '176px',
  [theme.breakpoints.down('md')]: {
    marginTop: '20px',
    width: '100%',
    '&:nth-of-type(2)': {
      borderTop: isCatering ? 0 : `1px solid ${theme.palette.borders.primary}`,
      marginTop: isCatering ? '0' : '10px',
      paddingTop: '1rem'
    }
  },
  [theme.breakpoints.up('md')]: {
    '&:nth-of-type(2)': {
      paddingTop: 0,
      borderTop: 0,
      marginLeft: isCatering ? '0' : '20px'
    },
    marginTop: 0
  }
}));

const LocationCardFulfillmentTypeGridItem = ({
  children,
  isFullWidth,
  isCatering
}) => {
  return (
    <StyledBox isCatering={isCatering} isFullWidth={isFullWidth}>
      {children}
    </StyledBox>
  );
};

LocationCardFulfillmentTypeGridItem.propTypes = {
  children: CHILDREN_PROP_TYPES.isRequired,
  isFullWidth: PropTypes.bool,
  isCatering: PropTypes.bool
};

LocationCardFulfillmentTypeGridItem.defaultProps = {
  isFullWidth: false,
  isCatering: false
};

export default LocationCardFulfillmentTypeGridItem;
